import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class ControlBarreras {
  static abrirBarreraEntradaDestare () {
    const axios = getAxiosInstance()
    const promise = axios.get(`abrir_barrera_entrada_destare`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static abrirBarreraSalidaDestare () {
    const axios = getAxiosInstance()
    const promise = axios.get(`abrir_barrera_salida_destare`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static cerrarBarreraEntradaDestare () {
    const axios = getAxiosInstance()
    const promise = axios.get(`cerrar_barrera_entrada_destare`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static cerrarBarreraSalidaDestare () {
    const axios = getAxiosInstance()
    const promise = axios.get(`cerrar_barrera_salida_destare`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static abrirBarreraEntradaBruto () {
    const axios = getAxiosInstance()
    const promise = axios.get(`abrir_barrera_entrada_bruto`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static cerrarBarreraEntradaBruto () {
    const axios = getAxiosInstance()
    const promise = axios.get(`cerrar_barrera_entrada_bruto`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static abrirBarreraSalidaBruto () {
    const axios = getAxiosInstance()
    const promise = axios.get(`abrir_barrera_salida_bruto`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static cerrarBarreraSalidaBruto () {
    const axios = getAxiosInstance()
    const promise = axios.get(`cerrar_barrera_salida_bruto`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static activarBarreraAutomaticaDestare () {
    const axios = getAxiosInstance()
    const promise = axios.get(`activar_barrera_automatico_destare`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static desactivarBarreraAutomaticaDestare () {
    const axios = getAxiosInstance()
    const promise = axios.get(`desactivar_barrera_automatico_destare`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static activarBarreraAutomaticoBruto () {
    const axios = getAxiosInstance()
    const promise = axios.get(`activar_barrera_automatico_bruto`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static desactivarBarreraAutomaticoBruto () {
    const axios = getAxiosInstance()
    const promise = axios.get(`desactivar_barrera_automatico_bruto`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static forzarBarreraDestare () {
    const axios = getAxiosInstance()
    const promise = axios.get(`forzar_barrera_destare`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static anularForzarBarreraDestare () {
    const axios = getAxiosInstance()
    const promise = axios.get(`anular_forzar_barrera_destare`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static forzarBarreraBruto () {
    const axios = getAxiosInstance()
    const promise = axios.get(`forzar_barrera_bruto`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static anularForzarBarreraBruto () {
    const axios = getAxiosInstance()
    const promise = axios.get(`anular_forzar_barrera_bruto`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static getMotivosActividadBarreraBruto () {
    const axios = getAxiosInstance()
    const promise = axios.get(`motivo_de_cambio_estado_barrera`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static getRegistrosActividadBarreraBruto () {
    const axios = getAxiosInstance()
    const promise = axios.get(`registro_actividad_barrera_ingreso?r=` +
    `{"limite":100, "orden": ["d:fecha_de_referencia"]}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static getRegistrosActividadBarreraBrutoEntreFechas (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}, "orden": ["d:fecha_de_referencia"]}`
    const promise = axios.get(`registro_actividad_barrera_ingreso_entre_fechas?r=${filtro}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static submitMotivoActividadBarreraBruto (balanza, motivo, ultimoPeso) {
    const axios = getAxiosInstance()
    const promise = axios.post(`registro_actividad_barrera_ingreso`,
      `{"valores": {"balanza": "${balanza}", "motivo": "${motivo}", "ultimo_peso_de_equilibrio": "${ultimoPeso}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result)
  }

  static getEstadoBarreraEntradaDestare () {
    const axios = getAxiosInstance()
    const promise = axios.get(`estado_barrera_entrada_destare`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data[0])
  }

  static getEstadoBarreraSalidaDestare () {
    const axios = getAxiosInstance()
    const promise = axios.get(`estado_barrera_salida_destare`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data[0])
  }

  static getEstadoBarrerasBruto () {
    const axios = getAxiosInstance()
    const promise = axios.get(`estado_barreras_bruto`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }
}

export default ControlBarreras
